import { Shared_FormTemplate_QuestionFragment } from "~/shared/components/FormTemplate/fragments/fragments.generated";

import { FormTemplateQuestionFormInputs } from "../components/FormTemplateQuestionForm";

export function extractFormData(question: Shared_FormTemplate_QuestionFragment): FormTemplateQuestionFormInputs {
    let multiline: boolean | undefined;
    let options: { id: string; name: string; key: string }[] | undefined;
    let conditionSelectedQuestion: string | undefined;
    let conditionSelectedQuestionOption: string | undefined;
    let conditionOrConditions:
        | {
              id: string;
              conditionSelectedQuestion?: string;
              conditionSelectedQuestionOption?: string;
          }[]
        | undefined;

    switch (question.type.__typename) {
        case "GqlSettingsFormTemplateQuestionTypeText":
            multiline = question.type.multiline;
            break;
        case "GqlSettingsFormTemplateQuestionTypeSelect":
        case "GqlSettingsFormTemplateQuestionTypeDropdown":
            options = question.type.options;
            break;
    }

    switch (question.condition.__typename) {
        case "GqlSettingsFormTemplateQuestionConditionIsEqual":
            conditionSelectedQuestion = question.condition.fieldKey;
            conditionSelectedQuestionOption = question.condition.value;
            break;
        case "GqlSettingsFormTemplateQuestionConditionOr":
            conditionOrConditions = question.condition.conditions.map(condition => ({
                id: condition.id,
                conditionSelectedQuestion: condition.fieldKey,
                conditionSelectedQuestionOption: condition.value,
            }));
    }

    return {
        name: question.name,
        isRequired: question.isRequired ?? false,
        showToClientUser: question.showToClientUser ?? false,
        description: question.description ?? "",
        placeholder: question.placeholder ?? "",
        tags: question.tags,
        type: question.type ?? { __typename: undefined },
        multiline,
        options,
        condition: question.condition,
        conditionSelectedQuestion,
        conditionSelectedQuestionOption,
        conditionOrConditions,
    };
}
